import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {actions as AreaActions} from '../../../redux/modules/Area'
import {actions as MarkTypesActions} from '../../../redux/modules/MarkType'
import {actions as MarkRulesActions} from '../../../redux/modules/MarkRules'
import {actions as RegistrationActions} from '../../../redux/modules/Registration'
import {actions as cartActions} from '../../../redux/modules/Cart'
import ParkTicketConfigurator from './ParkTicketConfigurator'
import SostaOnlineApiService from '../../../services/SostaOnlineApiService'

const VEHICLE_TYPES = [
  {name: 'Proprietà'},
  {name: 'Noleggio'},
  {name: "Comodato d'uso"},
  {name: 'Auto Aziendale'},
  {name: 'Auto Aziendale in uso esclusivo'},
  {name: 'Proprietà Aziendale'}
]

const mapStateToProps = (state) => {
  return {
    registration: state.registration,
    markTypes: state.markTypes,
    markRules: state.markRules,
    cart: state.cart
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch,
    areaActions: bindActionCreators(AreaActions, dispatch),
    markRulesActions: bindActionCreators(MarkRulesActions, dispatch),
    markTypesActions: bindActionCreators(MarkTypesActions, dispatch),
    registrationActions: bindActionCreators(RegistrationActions, dispatch),
    cartActions: bindActionCreators(cartActions, dispatch)
  }
}

class ParkTicketConfiguratorContainer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      loading: true,
      formErrors: null,
      user: {},
      parkTicketTypes: []
    }

    this.onSubmit = this.onSubmit.bind(this)
  }

  componentWillMount () {
    this.setState({loading: true})
    SostaOnlineApiService.fetchUserMe().then(user => {
      this.setState({user: user.data})

      return SostaOnlineApiService.fetchParkTicketTypes()
    }).then(parkTicketTypes => {
      this.setState({parkTicketTypes: parkTicketTypes.data, loading: false})
    })
  }

  onSubmit (values) {
    this.setState({formErrors: null, loadingCreation: true})
    let obj = {
      startDate: values.startDate,
      parkTicketTypeId: values.parkTicketType.id,
      parkTicketType: values.parkTicketType,
      quantity: 1
    }

    if (values.mark) {
      obj.markId = values.mark.id
      obj.mark = values.mark
    } else {
      let vehicle = values.vehicle
      if (!vehicle.id) {
        vehicle = {
          plate_number: values.vehicle.plate_number,
          type: values.vehicleType
        }
      }
      obj.vehicle = vehicle
    }

    SostaOnlineApiService.createCartItem(obj).then(result => {
      this.props.history.push('/user-area/cart')
    })
    // this.props.cartActions.addItem(obj);

    /* SostaOnlineApiService.buyParkingTickets([obj]).then(data => {
            console.log(data);
        }); */
  }

  render () {
    if (this.state.loading) {
      return (<div>Caricamento in corso...</div>)
    }

    return (<ParkTicketConfigurator
      user={this.state.user}
      parkTicketTypes={this.state.parkTicketTypes}
      formErrors={this.state.formErrors}
      vehicleTypes={VEHICLE_TYPES}
      onSubmit={this.onSubmit} />)
  }
}

ParkTicketConfiguratorContainer.propTypes = {
}

export default connect(mapStateToProps, mapDispatchToProps)(ParkTicketConfiguratorContainer)



// WEBPACK FOOTER //
// ./src/containers/UserArea/ParkTicket/ParkTicketConfiguratorContainer.js